exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-0f59901d]{width:100%}table tr[data-v-0f59901d]{height:40px}.failed[data-v-0f59901d]{background:red}.failed[data-v-0f59901d],.passed[data-v-0f59901d]{color:#fff;padding:2px 15px;border-radius:10px;font-size:14px;font-weight:700}.passed[data-v-0f59901d]{background:#90ee90}", ""]);

// exports
